import type { RouteLocationRaw } from '#vue-router'
import type { Alert, ToastObject } from '~/types/toast'

const DEFAULT_DURATION = 5000

type ToastAction = 'CONFIRM' | 'ROUTE'

export default defineNuxtPlugin(() => {
  const alerts = ref<Alert[]>([])
  const authErrorAlert = ref<Alert | undefined>(undefined)

  const getAction = (action: ToastAction, to?: RouteLocationRaw) => {
    const actionClasses = 'font-normal text-transform-unset'
    const actions = {
      CONFIRM: [
        {
          class: actionClasses,
          text: 'OK',
          onClick: (_: Event, toastObject: ToastObject) => toastObject.close(),
        },
      ],
      ROUTE: [
        {
          class: actionClasses,
          text: 'View',
          href: to,
        },
      ],
    }

    return actions[action]
  }

  const show = (
    message: string,
    action: ToastAction,
    to?: RouteLocationRaw,
  ) => {
    alerts.value.push({
      id: Date.now(),
      message,
      duration: DEFAULT_DURATION,
      actions: getAction(action, to),
    })
  }

  const showAuthError = (
    message: string,
    action: ToastAction,
    to?: RouteLocationRaw,
  ) => {
    if (authErrorAlert.value) {
      close(authErrorAlert.value.id)
      setTimeout(() => {
        authErrorAlert.value = {
          id: Date.now(),
          message,
          duration: DEFAULT_DURATION,
          actions: getAction(action, to),
        }
      }, 500)
    } else {
      authErrorAlert.value = {
        id: Date.now(),
        message,
        duration: DEFAULT_DURATION,
        actions: getAction(action, to),
      }
    }
  }

  const close = (toastId: number) => {
    alerts.value = alerts.value.filter(({ id }) => id !== toastId)
    authErrorAlert.value = undefined
  }

  return {
    provide: {
      alert: {
        alerts,
        authErrorAlert,
        show,
        close,
        showAuthError,
      },
    },
  }
})
